var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"branding-header text-center"},[_c('img',{staticClass:"logo-img",attrs:{"src":"/app/guest-checkin-images/outshinery-barrel-creek-logo-banner.png","alt":"Barrel Creek Winery Logo","height":"100"}})])
}]

export { render, staticRenderFns }